import { isProductionBuildType, isLocalhost, isStaging } from '@/environment-detection'
import { loadHotjarService } from './hotjar'
import { loadSegmentService } from './segment'

export const loadAllAnalyticsServices = () => {
  if (isProductionBuildType() && !isStaging()) {
    loadSegmentService()
  }

  if (!isLocalhost()) {
    loadHotjarService()
  }
}
